module.exports = __webpack_public_path__ + "media/images/logos/react-910a1234b27a1ba45af7c13a97737429.svg";